<template>
  <div class="power-curve-wrap">
    <div ref="title" class="flex flex-row items-center justify-between  w-full">
      <span class="power-curve-title">Power Curve</span>
      <span v-if="!isBrandUser" class="main-color" style="font-size:12px; font-weight: 200">{{ powerBetween }}</span>
    </div>


    <div class="right">
      <div
          id="spec-pie"
          ref="specPie"
          :class="hasRecommendCurve ? 'power-curve-size': 'power-curve-size-big'">
      </div>

      <div class="flex flex-row items-center justify-between pl-4  text-12px" v-if="isBrandUser">
        <div class="ctrl-wrap flex flex-col items-center " v-for="item in 8" :key="item">
          <div style="font-size:12px;padding: 0px 10px" @click="onChangePower('+',item)">+</div>
          <span class="text-10px" style="color:#D9D9D9">---</span>
          <div style="font-size:12px;padding: 0px 10px" @click="onChangePower('-',item)">-</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import { util } from "echarts";
import { calcMaxPower, calcPower, calcVoltageFloorInt, calcVoltageRoundInt } from "@/util/utils";
import { lineChartHomeBlue } from "@/config/echarts-data";
import userMixin from "@/mixins/userMixin";
import log from "@/util/log";

const graphic = require("echarts/lib/util/graphic");
export default {
  name: "PowerCurve",
  mixins: [userMixin],
  props: {
    powers: {
      type: Array,
      default: () => {
        return [[1, 2], [2, 3], [3, 4], [4, 1], [5, 3], [6, 3.3], [7, 1], [8, 3]];
      }
    },
    maxVoltage: {
      type: Number,
      default: 3500
    },
    minVoltage: {
      type: Number,
      default: 300
    },
    r: {
      type: Number,
      default: 1.2
    },
    grid: {
      type: Object,
      default: () => {
        return {
          top: "40px", // 设置顶部边距为 20%
          bottom: "20%", // 设置底部边距为 20%
          right: "16px",
          left: "32px"
        };
      }
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    hasRecommendCurve: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      lineChart: null,
      timeoutId: -1,

      symbolSize: 14,
      offsetY: 0
    };
  },
  methods: {
    changeVoltage(index, p) {
      const voltages = JSON.parse(JSON.stringify(this.powers));
      voltages[index][1] = p;
      this.$emit("change", voltages);
      // return voltages
    },
    resetSymbol() {
      const options = this.lineChart.getOption();

      options.series[0].data.forEach((item, index) => {
        item.label.offset = [0, 0];
        item.label.formatter = `${item.value[1].toFixed(1)}W`;
      });
      this.lineChart.setOption(options);
    },
    onChangePower(type, i) {
      const index = i - 1;
      const serie = this.lineChart.getOption().series[0];
      let currentPower = 0.1;
      currentPower = serie.data[index].value[1];
      //用当前功率计算出电压
      let v = calcVoltageRoundInt(currentPower, this.r);
      switch (type) {
        case "+":
          v += 100;
          break;
        case "-":
          v -= 100;
          break;
      }
      log(`最大的限制电压 ${this.maxVoltage} 最小的限制电压: ${this.minVoltage}`);
      if (v > this.maxVoltage || v < this.minVoltage) {
        return;
      }
      log(`上下控制电压 ${v}`);
      //重新计算功率
      const p = calcPower(v, this.r, 10);

      this.powers[index][1] = p;
      this.refreshCurve(this.isBrandUser, index);
      this.reloadTimeout();
    },
    reloadTimeout() {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.resetSymbol, 2000);
    },
    refreshCurve(draggable = false, dataIndex = undefined) {
      const myChart = this.lineChart;
      if (!myChart) {
        return;
      }


      const powers = this.powers;
      const options = myChart.getOption();
      options.series[0].data.forEach((item, index) => {
        const showImage = index === dataIndex;
        item.value[1] = powers[index][1];
        item.label.offset = showImage ? [0, 10] : [0, 0];
        item.label.formatter = showImage ? `{a|${item.value[1].toFixed(1)}W}` : `${item.value[1].toFixed(1)}W`;
      });
      this.lineChart.setOption(options);

      if (draggable) {
        const _that = this;
        const symbolSize = this.symbolSize;
        const myChart = this.lineChart;
        this.lineChart.setOption({
          graphic: util.map(this.powers, function(item, dataIndex) {
            return {
              type: "circle",
              position: myChart.convertToPixel("grid", item),
              shape: {
                r: symbolSize * 2
              },
              invisible: true,
              draggable: true,
              ondrag: util.curry(function(dataIndex, dx) {
                _that.onPointDragging(dataIndex, dx, this);
              }, dataIndex),
              z: 100
            };
          })
        });
      }


      this.$nextTick(() => {
        myChart.resize();
      });
    },

    onPointDragging(dataIndex, dx, that) {
      const r = this.r == -1 ? 1.2 : this.r;
      const maxVoltage = this.maxVoltage;
      const minVoltage = this.minVoltage;
      const myChart = this.lineChart;
      const symbolSize = this.symbolSize;

      dx.event.preventDefault();
      const point = myChart.convertFromPixel("grid", that.position);
      const maxPower = calcMaxPower(maxVoltage, r);
      log(`最大功率限制 = ${maxPower}`);
      log(`point = ${point}  `);
      const y = point[1] >= maxPower ? maxPower : (point[1] <= 0.1 ? 0.1 : point[1]);

      let v = 0;
      if (that.offsetY === 0) {
        v = calcVoltageRoundInt(y, r);
      } else {
        const offsetY = that.offsetY - dx.offsetY;
        if (offsetY > 0) {
          log("上拖动");
          v = calcVoltageRoundInt(y, r);
        } else {
          log("下拖动");
          v = calcVoltageFloorInt(y, r);
        }
        this.offsetY = dx.offsetY;
      }

      log(`电压 = ${v}`);
      if (v > maxVoltage || v < minVoltage) {
        return;
      }
      const p = calcPower(v, r, 10);
      log(`point y =  ${y} `);
      log(`功率 = ${parseFloat(p.toFixed(1))}`);


      this.powers[dataIndex][1] = y;
      this.changeVoltage(dataIndex, y);
      // const powers = this.powers.map((item, index) => {
      //   return createLineChartLabel(item[0], index === dataIndex ? p : item[1], index === dataIndex);
      // });
      const options = myChart.getOption();
      options.series[0].data.forEach((item, index) => {
        const showImage = index === dataIndex;
        item.value[1] = showImage ? p : item.value[1];
        item.label.offset = showImage ? [0, 10] : [0, 0];
        item.label.formatter = showImage ? `{a|${item.value[1].toFixed(1)}W}` : `${item.value[1].toFixed(1)}W`;

      });
      this.changeVoltage(dataIndex, p);


      const _that = this;
      myChart.setOption({
        series: options.series,
        graphic: util.map(this.powers, function(item, dataIndex) {
          return {
            type: "circle",
            position: myChart.convertToPixel("grid", item),
            shape: {
              r: symbolSize * 2
            },
            invisible: true,
            draggable: true,
            ondrag: util.curry(function(dataIndex, dx) {
              _that.onPointDragging(dataIndex, dx, this);
            }, dataIndex),
            z: 100
          };
        })
      });

      // log(`曲线 = ${JSON.stringify(voltages)}`);

      this.reloadTimeout.call(this);
    }
  },
  computed: {
    powerBetween() {
      const powers = this.powers.map(item => item[1]);
      const minPower = Math.min(...powers);
      const maxPower = Math.max(...powers);
      return `${minPower}W-${maxPower}W`;
    }
  },
  mounted() {

    this.$nextTick(() => {
      log(this.$refs.title.clientWidth);
      const width = this.$refs.title.clientWidth;
      this.$refs.specPie.style.width = `${width}px`;
      const _that = this;
      const myChart = this.$echarts.init(this.$refs.specPie);
      this.lineChart = myChart;
      const symbolSize = this.symbolSize;
      myChart.setOption(lineChartHomeBlue(_that.powers, this.showLabel, this.grid));
      if (this.isBrandUser) {
        myChart.setOption({
          graphic: util.map(_that.powers, function(item, dataIndex) {
            return {
              type: "circle",
              position: myChart.convertToPixel("grid", item),
              shape: {
                r: symbolSize * 2
              },
              invisible: true,
              draggable: true,
              ondrag: util.curry(function(dataIndex, dx) {
                _that.onPointDragging(dataIndex, dx, this);
              }, dataIndex),
              z: 100
            };
          })
        });
      }
      this.$refs.specPie.addEventListener("touchstart", function(e) {
        e.preventDefault();
      });
      myChart.on("touchstart", function() {
        log("touch start");
      });
      window.addEventListener("resize", () => {
        console.log('resize')
        if (this.isBrandUser) {
          myChart.setOption({
            graphic: util.map(_that.powers, function(item, dataIndex) {
              return {
                position: myChart.convertToPixel("grid", item)
              };
            })
          });

        }
        this.refreshCurve(this.isBrandUser)
        this.$nextTick(()=> {
          myChart.resize()
        })
      });
    });
  }
};
</script>


<style scoped lang="less">
.power-curve-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .power-curve-title {
    font-size: 16px;
    font-weight: normal;
  }

  .left {
    display: flex;
    flex-direction: column;

  }

  .right {
    flex: 1;
  }
}

.ctrl-wrap {
  border-radius: 8px;
  border: 1px #E8E8E8 solid;
}

//// iPhoneX、iPhoneXS
//@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
//  .power-curve-size {
//    width: 348px;
//    height: 157px
//  }
//}
.power-curve-size {
  width: 348px;
  height: 150px
}

// iPhone13
@media only screen and (min-device-width: 390px)  and (-webkit-device-pixel-ratio: 3) {
  .power-curve-size {
    width: 357px;
    height: 180px
  }
}

// iPhoneXSMax
@media only screen and (min-device-width: 414px)  and (-webkit-device-pixel-ratio: 3) {
  .power-curve-size {
    width: 414px;
    height: 190px
  }
}

// iPhone13 pro maxs
@media only screen and (min-device-width: 428px)  and (-webkit-device-pixel-ratio: 3) {
  .power-curve-size {
    width: 357px;
    height: 230px
  }
}


.power-curve-size-big {
  width: 348px;
  height: 280px
}

// iPhone13
@media only screen and (min-device-width: 390px)  and (-webkit-device-pixel-ratio: 3) {
  .power-curve-size-big {
    width: 357px;
    height: 300px
  }
}

// iPhoneXSMax
@media only screen and (min-device-width: 414px)  and (-webkit-device-pixel-ratio: 3) {
  .power-curve-size-big {
    width: 414px;
    height: 350px
  }
}

// iPhone13 pro maxs
@media only screen and (min-device-width: 428px)  and (-webkit-device-pixel-ratio: 3) {
  .power-curve-size-big {
    width: 357px;
    height: 400px
  }
}

</style>